import { GetAgenticLogicTemplateSourceResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const getAgenticLogicTemplateSource = async (templateId: string) => {
  const response = await api.get<GetAgenticLogicTemplateSourceResponseBodyType>(
    `/v2/agentic-logic/templates/${templateId}/source`
  );
  return response.data;
};

/**
 * The read-only implementation source of one trusted template — the "logic
 * that will run" view. `enabled` gates the fetch to when the view is open,
 * because the payload is the whole template library slice (~50-100KB).
 */
export const useAgenticLogicTemplateSource = (
  templateId: string,
  { enabled = true }: { enabled?: boolean } = {}
) =>
  useQuery<GetAgenticLogicTemplateSourceResponseBodyType, Error>({
    queryKey: agenticLogicKeys.templateSource(templateId),
    queryFn: () => getAgenticLogicTemplateSource(templateId),
    staleTime: Number.POSITIVE_INFINITY,
    enabled,
  });
